module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/case-dairys/case-dairy-menu/case-dairy-menu/case-dairy-menu.component.html
// module id = ./src/app/case-dairys/case-dairy-menu/case-dairy-menu/case-dairy-menu.component.html
// module chunks = main